import { render, staticRenderFns } from "./ServiceScheduler.vue?vue&type=template&id=c5235b28&scoped=true&"
import script from "./ServiceScheduler.vue?vue&type=script&lang=js&"
export * from "./ServiceScheduler.vue?vue&type=script&lang=js&"
import style0 from "./ServiceScheduler.vue?vue&type=style&index=0&id=c5235b28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5235b28",
  null
  
)

export default component.exports